import React, {useRef} from "react";
import _ from "lodash";

function useCancelableDebounce(delay = 500) {
    const ref = useRef(null);

    const start = (callback, event) => {
        if (ref.current) {
            ref.current.cancel();
        }

        ref.current = _.debounce((event) => {
            callback(event.target.value);
            ref.current = null;
        }, delay);

        return ref.current(event);
    }

    return start;
}

export default useCancelableDebounce;